import { Link } from "react-router-dom";
import classes from "./footer.module.css";
import { openCookieSettings } from "../../../utils/consent";

const Footer = () => {
  return (
    <footer className={`flex full-width ${classes.footer}`}>
      <span>Copyright &copy;{new Date().getFullYear()}. All rights reserved by Awasource Ltd</span>
      <div>
        <Link to="/terms-of-service">Terms of Use</Link>
        <span> | </span>
        <Link to="/privacy-policy"> Privacy Policy</Link>
        <span> | </span>
        <button
          type="button"
          onClick={openCookieSettings}
          style={{ background: "none", border: 0, padding: 0, font: "inherit", color: "inherit", cursor: "pointer" }}
        >
          Cookie settings
        </button>
      </div>
    </footer>
  );
};

export default Footer;
